import React, { useState, useEffect, useContext } from 'react';
import { Modal, Button, Image } from 'edcom-ui';
import { listen } from '../../services/events';
import { DISPATCH_PAYWALL_EVENT } from './constants';
import styles from './FeatureWall.module.less';
import { writeCookieToDocument } from '../../edcom-ui/hooks/useCookie';
import track, { trackGA } from '../../services/track';
import AccountContext from '../../services/AccountContext';
import { useRouter } from 'next/router';
import { pushAppRoute } from '../../components/links/AppLink';

const listSection = (
  <>
    <ul>
      <li>
        <strong>Unlimited</strong> downloads
      </li>
      <li>Guided Lessons to cultivate a joy for learning</li>
    </ul>
    <b>
      <i>...and more!</i>
    </b>
  </>
);

function FeatureWall() {
  useEffect(() => {
    return listen(DISPATCH_PAYWALL_EVENT, detail => {
      setOpen(true);
      const { isPayWall, ...modalData } = detail;
      setModalData(modalData);
      setIsPayWall(isPayWall);
    });
  }, []);
  const [open, setOpen] = useState(false);
  const [modalData, setModalData] = useState({});
  const [isPayWall, setIsPayWall] = useState(false);
  const router = useRouter();
  const { isPremium, isSchoolAdmin } = useContext(AccountContext);

  const {
    contentType,
    contentId,
    title,
    text,
    name = '',
    feature = '',
    section = '',
  } = modalData;

  // Analytics tracking
  useEffect(() => {
    if (!open) {
      return;
    }

    track(isPayWall ? 'Hit Free Limit' : 'Hit Feature Wall', {
      feature,
      // TODO: get section from current url (e.g. /worksheet/article/ means "Worksheet Detail")
      section,
      contentType,
      contentId,
      name,
    });
    if (isPayWall && section.length > 0) {
      trackGA(section.toLowerCase(), 'paywall open');
    }
  }, [open]);

  const titleSection = isPayWall ? (
    <>
      <h3>
        Continue Your<br></br>Learning Adventure!
      </h3>
    </>
  ) : (
    <>
      <h3 className={styles.title}>{title}</h3>
    </>
  );

  const textSection = isPayWall ? (
    isSchoolAdmin ? (
      <>
        <p>
          You’ve reached your Basic membership limit for this month. To get
          unlimited access to our resource library, you must be added to the
          teachers list on your school account.
        </p>
      </>
    ) : (
      <>
        <p>
          You’ve reached your Basic membership limit for this month. Become a
          Premium member to get:
        </p>
      </>
    )
  ) : (
    <>
      <div dangerouslySetInnerHTML={{ __html: text }} />
    </>
  );

  // Set Content Type & ID as cookies so that users can be redirected back to this content detail page after pricing page
  if (!isSchoolAdmin && !isPremium) {
    if (contentType && contentId) {
      // Cache for 30 minutes
      const maxAge = 1800;
      writeCookieToDocument(`PaywallOriginContentType`, contentType, {
        'max-age': maxAge,
      });
      writeCookieToDocument(`PaywallOriginContentId`, contentId, {
        'max-age': maxAge,
      });
    }
  }

  const buttonSection =
    isSchoolAdmin && !isPremium ? (
      <div className={styles.buttons}>
        <div className={styles.upgradeSection}>
          <Button
            color="tertiary"
            className={styles.accountSwitcherNonPremium}
            onClick={() => pushAppRoute(router, '/my/school-admin/settings/')}
          >
            Review school settings
          </Button>
        </div>
      </div>
    ) : (
      <div className={styles.buttons}>
        <div className={styles.upgradeSection}>
          <Button
            color="premium"
            className={styles.upgradeButton}
            href={`/pricing/`}
          >
            Upgrade
          </Button>
        </div>
      </div>
    );

  return (
    <Modal
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      className={styles.featureWallModal}
    >
      <div className={styles.container}>
        <div className={styles.backgroundImage}>
          <Image
            src="https://cdn.education.com/files/static/paywallModel/mascots-background.png"
            alt="Mascots"
            className={styles.mascots}
          />
          <Image
            src="https://cdn.education.com/files/static/paywallModel/star-left.png"
            alt="Star"
            className={styles.starLeft}
          />
          <Image
            src="https://cdn.education.com/files/static/paywallModel/star-right.png"
            alt="Star"
            className={styles.starRight}
          />
        </div>
        <div className={styles.contentSection}>
          {titleSection}
          {textSection}
          {isSchoolAdmin ? null : listSection}
          {buttonSection}
        </div>
      </div>
    </Modal>
  );
}

export default FeatureWall;
